import { createReducer, updateDeepState } from "../handlers"
import types from "./types"

const initialState = {
  isActive: undefined,
  time: undefined, // milisegundos
  unit: undefined
}

const setOperatorDisabled = (state, action) => {
  const { operatorAutoDisabled } = action
  return updateDeepState(state, operatorAutoDisabled)
}

export default createReducer(initialState, {
  [types.OPERATOR_DISABLED_SET]: setOperatorDisabled
})